import { SVGProps } from 'react'

const Ink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 275 275"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M275 137.5C275 61.5608 213.439 -3.31941e-06 137.5 0C61.5608 3.31941e-06 -3.31941e-06 61.5608 0 137.5C3.31941e-06 213.439 61.5608 275 137.5 275C213.439 275 275 213.439 275 137.5ZM157.125 240.407C157.125 249.735 149.469 257.317 138.602 257.535C138.301 257.538 138 257.539 137.698 257.54H137.302C71.0969 257.433 17.4603 203.73 17.4603 137.5C17.4603 71.2041 71.2039 17.4605 137.5 17.4605C137.857 17.4605 138.215 17.4621 138.571 17.4652C150.834 17.6836 157.125 25.2654 157.125 34.5929C157.125 44.0859 148.733 51.0715 139.843 51.0715C130.952 51.0715 130.516 51.0715 122.006 51.7534C113.495 52.4354 104.695 59.4209 104.695 68.8859C104.695 78.4071 112.43 86.0745 122.006 86.0745H197.48C207.028 86.0745 214.762 93.742 214.762 103.207C214.762 112.672 207.028 120.339 197.48 120.339H81.2298C71.6539 120.339 63.9195 128.035 63.9195 137.528C63.9195 146.993 71.6539 154.661 81.2298 154.661H139.843C149.391 154.661 157.125 162.328 157.125 171.821C157.125 181.286 149.391 188.954 139.843 188.954H122.006C112.43 188.954 104.695 196.621 104.695 206.086C104.695 215.579 112.622 222.509 122.006 223.219C122.745 223.275 123.422 223.326 124.045 223.374C127.347 223.625 129.151 223.763 130.958 223.838C133.134 223.929 135.314 223.929 140.119 223.929C149.667 223.929 157.125 230.942 157.125 240.407Z"
      fill="#7132F5"
    />
  </svg>
)

export default Ink
